import styled from "styled-components";
import BlueButton from './blueButton'
import { darken } from 'polished';

const SIconButton = styled(BlueButton)`
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    background-color: ${props => props.bg};
    color: ${props => props.color};
    font-size: 30px;

    &:hover{
        background-color: ${props => (darken(0.05, props.bg))};
    }
    &:active{
        background-color: ${props => (darken(0.1, props.bg))};
    }
`;

export default function IconButton(props){
    return(
        <SIconButton {...props}>{props.children}</SIconButton>
    )
}